import React, { FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  width: string;
  height: string;
  fill?: string;
  className?: string;
}

const Search: FC<Props> = ({ className, height, width, fill = colors.lapel }) => {
  return (
    <Svg
      className={className}
      height={height}
      title="Search icon"
      viewBox="0 0 24 24"
      width={width}
    >
      <path
        d="M20.42,19.5,17,16.17a8.1,8.1,0,1,0-.7.72l3.4,3.32a.5.5,0,1,0,.7-.71ZM3.93,11a7,7,0,1,1,7,7A7,7,0,0,1,3.93,11Z"
        fill={fill}
      />
      <rect fill="none" height="24" width="24" />
    </Svg>
  );
};

export default React.memo(Search);
